const compareTwoStrings = (a: string, b: string) => a.localeCompare(b);
export default compareTwoStrings;